export default __webpack_public_path__ + "static/media/raufu.c74bc544.png";